export class Controller {

    /** @ngInject */
    constructor($state, AccountsResource, Alert) {
        this.$state = $state;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
    }

    $onInit() {
        this.file = null;
        this.allowChangeOwner = true;
        this.verificationTypes = [
            {name: 'USER', selected: true},
            {name: 'ADMIN', selected: true},
            {name: 'THIRD_PARTY_FACEBOOK', selected: true},
        ];
        this.importUsersSampleCsv = require('./import-accounts-to-group.sample.csv');
    }

    selectCsv() {
        document.querySelector('input[type=file]').click();
    }

    uploadCSV() {

        const verificationTypes = this.verificationTypes
            .filter((verificationType) => verificationType.selected)
            .map((verificationType) => verificationType.name);

        this.AccountsResource
            .uploadUsers(this.companyId, verificationTypes, this.allowChangeOwner, this.file, this.group.id)
            .then((importResult) => this.$state.go('.result', {importResult}, {reload: '^'}))
            .catch(({status}) => {
                if (status === 500 || status === 413) {
                    this.Alert('danger', 'company.user-directories.manage-group.accounts.import.failed');
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-group/accounts/import/import-accounts-to-group.controller.js